import { Tab } from '../../../../../views/customer-base';
import { BillingTypeOptions } from '../../../../../views/customer-base/BillingHealthTab';
import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tabs: {
    [Tab.Performance]: 'Desempenho',
    [Tab.NewCustomers]: 'Novos Restaurantes',
    [Tab.CustomerHealth]: 'Saúde do Cliente',
    [Tab.LiveAndInactive]: 'Ativos e Inativos',
    [Tab.BillingHealth]: 'Saúde de Faturação',
  },
  labels: {
    sales_manager: 'Gestor de Vendas',
  },
  performance_tab: {
    table_columns: {
      name: 'Nome',
      sales_manager: 'Gestor de Vendas',
      orders: 'Pedidos',
      sales: 'Vendas',
      previous_month_sales: 'Receita do Mês Anterior',
    },
    labels: {
      sales_volume: 'Volume de Vendas:',
      all: 'Todos',
      click_to_sort: 'Clique para ordenar',
      no_data: 'Sem dados',
    },
    toasts: {
      failed_to_load_data: 'Erro ao carregar dados',
    },
  },

  new_restaurants_tab: {
    table_columns: {
      name: 'Nome',
      sales_manager: 'Gestor de Vendas',
      orders: 'Pedidos',
      sales: 'Vendas',
      days_live: 'Dias Ativos',
      early_performance: 'Desempenho Inicial',
    },
    labels: {
      click_to_sort: 'Clique para ordenar',
      no_data: 'Sem dados',
      only_with_early_performance: 'Apenas com desempenho inicial: ',
      early_performance_yes: '✔️ Sim',
      early_performance_no: '✗ Não',
    },
    toasts: {
      failed_to_load_data: 'Erro ao carregar dados',
    },
  },

  customer_health_tab: {
    titles: {
      sales_tiers: 'Níveis de Vendas',
      payments_ratio: 'Rácio de Pagamentos',
    },
    dataset_labels: {
      negative: 'Negativo ({{values}})',
      ok: 'OK ({{values}})',
      good: 'Bom ({{values}})',
      excellent: 'Excelente ({{values}})',
    },

    companies_preview_modal: {
      title: 'Pré-visualização de Restaurantes',
      table_columns: {
        name: 'Nome',
        sales_manager: 'Gestor de Vendas',
        orders: 'Pedidos',
        sales: 'Vendas',
        total_payments: 'Total de Pagamentos',
        payments_ratio: 'Rácio de Pagamentos',
      },
      labels: {
        close: 'Fechar',
        click_to_sort: 'Clique para ordenar',
        no_data: 'Sem dados',
      },
    },
    toasts: {
      failed_to_load_data: 'Erro ao carregar dados',
    },
  },

  live_and_inactive_tab: {
    dataset_labels: {
      live: 'Ativo',
      no_orders: 'Sem pedidos',
      no_conversion: 'Sem conversão',
    },
    toasts: {
      failed_to_load_data: 'Erro ao carregar dados',
    },
  },

  billing_health_tab: {
    filters: {
      billing_type: {
        label: 'Tipo de Faturação',
        options: {
          [BillingTypeOptions.Subscription]: 'Subscrição',
          [BillingTypeOptions.Manual]: 'Outro',
        },
      },
      high_risk_only: {
        label: 'Apenas clientes de alto risco',
      },
    },
    fields: {
      name: 'Nome',
      live_from: 'Ativo desde',
      billing_mode: {
        title: 'Fonte de faturação',
        options: {
          [BillingMode.Stripe]: 'Método de pagamento',
          [BillingMode.InternalInvoicing]: 'Vendas',
        },
      },
      trial_ends_at: 'Fim do período de teste',
      last_failed_invoice_amount: 'Valor da última fatura falhada',
      failed_payments_count: 'Nº de pagamentos falhados',
    },
    tags: {
      is_high_billing_risk_customer: 'Alto risco de faturação',
    },
    toasts: {
      failed_to_load_data: 'Erro ao carregar dados',
    },
  },
};
